import {Head, router} from "@inertiajs/react";
import {PageProps} from "@/types";
import axios from "axios";
import toast from "react-hot-toast";
import BillingPageLayout from "@/Pages/Billing/BillingPageLayout";
import PurchaseModal from "@/Pages/Dashboard/Purchase/PurchaseModal";
import {useState} from "react";
import PrimaryButton from "@/Components/PrimaryButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilm} from "@fortawesome/free-solid-svg-icons";
import {formatMinutes} from "@/utils/textFormatting";
import PaymentsTable from "@/Pages/Billing/Partials/PaymentsTable";
import Popover from "@/Components/Popover";
import CreditsUsageBreakdown from "@/Components/CreditsUsageBreakdown";

type BillingProps = {
    pendingPayments: any[],
    creditBalance: number,
    pricing: Record<string, number>
}

export default function CreditsPage({
    auth,
    pendingPayments,
    creditBalance,
    pricing,
    sessionFlash
}: PageProps<BillingProps>) {
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    const cancelPayment = (paymentId: string) => {
        axios.put(route('payment.cancel-pending', paymentId))
            .then(() => {
                toast.success('Payment cancelled');
                router.reload()
            }).catch(err => {
            const message = err.response?.data?.message || 'An error occurred while cancelling the payment';
            toast.error(message);
        });
    }

    return (
        <>
            <Head title="Billing"/>
            <BillingPageLayout>
                <PurchaseModal
                    show={showPurchaseModal}
                    onClose={() => setShowPurchaseModal(false)}
                    prices={pricing}
                />
                <div className="">
                    <div className="flex flex-row justify-between items-center mb-4">
                        <h1 className="text-2xl text-gray-900 dark:text-gray-100">Credits</h1>
                    </div>
                    <div className="flex flex-row justify-between items-center">
                        <div className="">
                            <p className="text-sm mb-0 text-gray-600 dark:text-gray-400">
                                Processing time remaining
                            </p>
                            <div className="flex items-center mt-1">

                                <h4 className="text-sm xl:text-base font-bold text-gray-900 dark:text-gray-100">{formatMinutes(creditBalance)}</h4>
                                {!auth.user?.is_trial && (
                                    <Popover trigger="hover" placement="right" content={<CreditsUsageBreakdown hours={creditBalance / 60} />}>
                                        <button type="button" className="ml-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                                            <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </Popover>
                                )}
                            </div>
                        </div>
                        <PrimaryButton className="self-center" onClick={() => setShowPurchaseModal(true)}>Purchase
                            <span className="hidden md:inline"> Credits</span></PrimaryButton>
                    </div>
                    <div className="py-8">
                        <div className="max-w-7xl mx-auto space-y-6">
                            <PaymentsTable cancelPayment={cancelPayment}/>


                        </div>
                    </div>
                </div>
            </BillingPageLayout>
        </>
    )
}
